import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, TrendingUp, Users, Globe } from "lucide-react";
import MarketingNav from "@/components/MarketingNav";
import MarketingFooter from "@/components/MarketingFooter";
import HtmlEmbed from "@/components/HtmlEmbed";
import api from "@/lib/api";

export default function Invest() {
  // Cognito form embed code lives in `/api/marketing/settings`. Admin can
  // paste/update it from the marketing-settings admin page without a deploy.
  const [embed, setEmbed] = useState("");
  useEffect(() => {
    api.get("/marketing/settings")
      .then((r) => setEmbed(r.data?.invest_embed || ""))
      .catch(() => setEmbed(""));
  }, []);

  return (
    <div className="bg-[#fbfcfc] min-h-screen">
      <MarketingNav />
      <section className="bloq-section">
        <div className="bloq-container">
          <div className="max-w-2xl mb-14">
            <p className="bloq-eyebrow">Invest in Bloq</p>
            <h1 className="bloq-display text-5xl sm:text-6xl mt-3 mb-5">
              Back the workspace <span className="bloq-gradient-text">replacing the stack.</span>
            </h1>
            <p className="text-lg text-[#4a4a52] leading-relaxed">
              We're building Bloq for the 60M+ knowledge workers whose entire revenue depends on
              the quality of conversations. If that sounds like a market worth owning — let's talk.
            </p>
          </div>
          <div className="grid sm:grid-cols-3 gap-5 mb-16">
            {[
              { icon: TrendingUp, t: "TAM", d: "$22B and growing — video, scheduling, CRM, and AI overlap." },
              { icon: Users, t: "ICP", d: "Solopreneurs, consultants, and service teams of 2–50." },
              { icon: Globe, t: "Wedge", d: "Replace five tools and a hundred tabs with one calm workspace." },
            ].map((s, i) => {
              const I = s.icon;
              return (
                <div key={i} className="bloq-card p-7">
                  <div className="w-11 h-11 rounded-lg flex items-center justify-center mb-4" style={{ background: "rgba(0,94,122,0.1)", color: "#005e7a" }}>
                    <I className="w-5 h-5" />
                  </div>
                  <p className="bloq-headline text-xl mb-2 text-[#005e7a]">{s.t}</p>
                  <p className="text-sm text-[#4a4a52] leading-relaxed">{s.d}</p>
                </div>
              );
            })}
          </div>

          {/* Investor form — Cognito embed paste-in slot. Falls back to a
              contact-form CTA when nothing's pasted yet. */}
          <div className="bloq-glass-strong p-10 rounded-2xl" data-testid="invest-form-card">
            <p className="bloq-eyebrow">Express interest</p>
            <h3 className="bloq-headline text-3xl mt-3 max-w-xl mb-4">
              We're raising a seed round of intentional capital from operators in SaaS, video, and AI.
            </h3>
            <p className="text-[#4a4a52] mb-8 max-w-xl">
              Memo, model, and roadmap available under NDA. Fill in the form below and we'll send the deck.
            </p>
            {embed ? (
              <HtmlEmbed
                html={embed}
                className="bloq-cognito-embed"
                testId="invest-cognito-embed"
              />
            ) : (
              <div className="border-2 border-dashed border-[#005e7a]/30 rounded-xl p-8 text-center bg-white/50">
                <p className="text-sm text-[#82828c] mb-4">Form coming soon.</p>
                <Link to="/contact" className="bloq-btn-primary inline-flex items-center gap-2" data-testid="invest-cta">
                  Request the deck via contact <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            )}
          </div>
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}
